import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { NavigationItems } from "../../utils/navigation/Navigation";
import {
  Button,
  Drawer,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import amccc_logo from "../../assets/amccc_logo.png";
import amcc_white from "../../assets/amc_white.png";
import { AiOutlinePhone, AiOutlineMail } from "react-icons/ai";
import { MdOutlineArrowOutward } from "react-icons/md";
import { MdClose, MdEmail, MdLocationOn } from "react-icons/md";

import DialogReusable from "../dialog/DialogReusable";
import amclogo from "../../assets/amclogo.png";
import { useSelector } from "react-redux";
import MainpageHook from "../../pages/HomePage/hooks/MainpageHook";
import { styled, useTheme } from "@mui/material/styles";
import { FaBars, FaPhoneAlt } from "react-icons/fa";
import Slide from "@mui/material/Slide";

import amc_blue from "../../assets/amc_blue2.png";

// css
import "./css/nav.css";

import Footer from "../footer/Footer";
import NavHook from "./hooks/NavHook";

const HideOnScroll = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Slide appear={false} direction="down" in={isVisible}>
      {children}
    </Slide>
  );
};

const drawerWidth = "100%";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,

  justifyContent: "flex-start",
}));

const NavigationBar = (props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const theme = useTheme();

  const reducer_data = useSelector((state) => state.GlobalReducer);

  const { ...param } = NavHook();
  const { ...goTo } = MainpageHook();

  const navigate = useNavigate();
  const location = useLocation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
  const isContactPage = location.pathname === "/contact";

  return (
    <div>
      <>
        <HideOnScroll {...props}>
          <AppBar
            elevation={0}
            sx={{
              backgroundColor: "#092b44",
              height: "80px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Toolbar>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 12, sm: 8, md: 12 }}
                    columnSpacing={{ xs: 1, sm: 3, md: 3 }}
                    justifyContent="center"
                  >
                    <Grid item xs={12} sm={12} md={10}>
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 12, sm: 12, md: 12 }}
                        columnSpacing={{ xs: 1, sm: 3, md: 3 }}
                      >
                        <Grid item xs={9} md={3}>
                          <div className="nav-holder">
                            <div>
                              <img
                                style={{
                                  marginRight: "60px",
                                  cursor: "pointer",
                                  zIndex: 100,
                                }}
                                src={amclogo}
                                height={40}
                                onClick={() => navigate("/")}
                              />
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs={1} md={4}>
                          <div className="nav-wrapper">
                            <div className="nav-container">
                              {NavigationItems.map((item, index) => (
                                <Typography
                                  onClick={() => goTo.handleLoading(item.route)}
                                  key={index}
                                  sx={{
                                    marginLeft: "20px",
                                    fontSize: "14px",
                                    fontWeight: 300,
                                    textTransform: "uppercase",
                                    cursor: "pointer",
                                    zIndex: 100,
                                    fontWeight: 700,
                                    "&:hover": {
                                      color: "#8EAC50",
                                    },
                                  }}
                                >
                                  {item.mainPageName}
                                </Typography>
                              ))}
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={1} md={4}>
                          <div className="contact-info-container">
                            <div className="contact-wrapper">
                              <AiOutlinePhone />
                              <p>09190792240</p>
                            </div>
                            <div className="contact-wrapper">
                              <AiOutlineMail />
                              <p>info.amc@ngcruz.com</p>
                            </div>
                            <div
                              className={`view-more-container ${
                                isContactPage ? "hidden" : ""
                              }`}
                              onClick={param.handleDialogOpen}
                            >
                              <p>Inquire Now</p>

                              <MdOutlineArrowOutward />
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={1} md={1} order={isMobile ? 1 : 4}>
                          <div
                            className={
                              isMobile ? "menu_icon-mobile" : "menu_icon"
                            }
                          >
                            <IconButton onClick={param.handleDrawerOpen}>
                              <FaBars className="actual-icon" />
                            </IconButton>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
            {isMobile ? (
              <Drawer
                sx={{
                  width: drawerWidth,
                  flexShrink: 0,
                  "& .MuiDrawer-paper": {
                    width: drawerWidth,
                  },
                }}
                variant="persistent"
                anchor="right"
                open={param.isDrawerOpen}
              >
                <DrawerHeader>
                  <IconButton onClick={param.handleDrawerClose}>
                    {theme.direction === "rtl" ? <MdClose /> : <MdClose />}
                  </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                  {NavigationItems.map((item) => (
                    <ListItem key={item} disablePadding>
                      <ListItemButton onClick={() => param.handleClick(item)}>
                        <ListItemIcon sx={{ color: "#044a67" }}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.mainPageName}
                          sx={{ color: "#044a67" }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>

                <Divider />

                <div className="nav-img-container">
                  <div className="img-holder">
                    <img className="img" src={amc_blue} alt="amc_logo" />
                  </div>
                </div>
                <div className="contact-no-mbl">
                  <div>
                    <div
                      style={{
                        display: "flex",
                        color: "#044a67",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <FaPhoneAlt />
                      <p style={{ margin: 0 }}>09190792240</p>
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        color: "#044a67",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <MdEmail />

                      <p style={{ margin: 0 }}>info.amc@ngcruz.com</p>
                    </div>
                  </div>
                  <div
                    className={`view-more-container ${
                      isContactPage ? "hidden" : ""
                    }`}
                    onClick={param.handleDialogOpen}
                  >
                    <p>Inquire Now</p>

                    <MdOutlineArrowOutward />
                  </div>

                  <div>
                    <div
                      style={{
                        display: "flex",
                        color: "#044a67",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {/* <MdLocationOn /> */}

                      <p style={{ margin: 0 }}>
                        {/* 9037 Cozy Bldg. Pallocan West Batangas City */}
                      </p>
                    </div>
                  </div>
                </div>
              </Drawer>
            ) : null}
            <DialogReusable
              isDialogOpen={param.isDialogOpen}
              onClose={param.handleDialogClose}
              onChangeText={(e, objectKey) => param.onChangeText(e, objectKey)}
              reducer_data={reducer_data}
              handleSubmit={param.handleSubmit}
            />
          </AppBar>
        </HideOnScroll>
        <div>
          <Outlet />
          {/* <Footer /> */}
        </div>
      </>
    </div>
  );
};

export default NavigationBar;
